<div class="crClock">
    <canvas #clockCanvas width="100" height="100"> </canvas>
    <img [src]="'assets/img/flags/' + img + '.png'">
</div>